import React from 'react';

const ProcurementHintBox = ({ title = 'Hướng dẫn nghiệp vụ', children }) => {
  return (
    <div className='bw_frm_box bw_mb_3'>
      <div className='bw_small_text' style={{ fontWeight: 700, marginBottom: 4 }}>
        {title}
      </div>
      <div className='bw_small_text'>{children}</div>
    </div>
  );
};

export default ProcurementHintBox;
